import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
    selector: 'social-share',
    templateUrl: './social-share.component.html',
    styleUrls: ['./social-share.component.scss'],
    standalone: false
})
export class SocialShareComponentGeneric implements OnInit {
    @Input('showText') showText = false;
    @ViewChild('shareBtn') shareBtn: ElementRef;

    // @ViewChild('shareMenu') shareMenu: ElementRef;
    isShareOpen = false;
    _includeButton:any;
    get includeButton():any{
        return this._includeButton;
    }
    @Input() set includeButton(value:any) {
        this._includeButton = value === 'false' ? false : true;
    }

    _shareBtns: any = ['facebook', 'twitter', 'whatsapp', 'email'];
    get shareBtns():any{
        return this._shareBtns;
    }
    @Input() set shareBtns(value:any) {
        if (typeof value === 'string'){
            this._shareBtns = value.split('|');
        }else{
            this._shareBtns = value || ['facebook', 'twitter', 'whatsapp', 'email'];
        }
    }

    @Input() IsListenUrl = true;
    @Input() url:string;
    @Input() titleEmail:string = '';
    @Input() bodyEmail:string = '';

    constructor(
                public renderer: Renderer2,
                protected router: Router,
                protected overlayContainer: OverlayContainer
    ) {

    }
    addOverlayClass(): void {
        this.overlayContainer.getContainerElement().classList.add('social-share-overlay');
    }

    removeOverlayClass(): void {
        this.overlayContainer.getContainerElement().classList.remove('social-share-overlay');
    }
    ngOnInit() {
        if(this.url){
            this.url = window.location.protocol + '//' + window.location.host + this.url;
        }else if(this.IsListenUrl) {
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((val: NavigationEnd) => {
                this.url = val.url;
            });
        }
    }

    share() {
        this.isShareOpen = !this.isShareOpen;
        location.hash = '';
    }

    // close() {
    //     this.isShareOpen = false;
    // }

    focusout(event) {

    }
    ngOnDestroy(): void {
        this.removeOverlayClass();
    }
}
